import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Dashboards from './pages/Dashboards';
import Studies from './pages/Studies';
import Faqs from './pages/Faqs';
import PleasantStreetMassing from './pages/PleasantStreetMassing';
import VoterLookup from './pages/VoterLookup';
import ChcaFaq from './pages/ChcaFaq';
import OutdoorLightingFaq from './pages/OutdoorLightingFaq';
import FaqPlatformFaq from './pages/FaqPlatformFaq';
import CryptoKioskFaq from './pages/CryptoKioskFaq';
import PsmodFaq from './pages/PsmodFaq';
import ReimburseTmmsFaq from './pages/ReimburseTmmsFaq';
import SchoolStaff from './pages/SchoolStaff';
import TownBudgets from './pages/TownBudgets';
import { GoverningDocsList, GoverningDocDetail } from './pages/GoverningDocs';
import Roadmap2030 from './pages/Roadmap2030';
import Carp2026 from './pages/Carp2026';
import UrbanForestry from './pages/UrbanForestry';
import OpenSpaceRec from './pages/OpenSpaceRec';
import ErscRecommendations from './pages/ErscRecommendations';
import VisionZero from './pages/VisionZero';
import AthleticFields from './pages/AthleticFields';
import Chip from './pages/Chip';
import DpwStrategic from './pages/DpwStrategic';
import HazardMitigation from './pages/HazardMitigation';
import HousingProduction from './pages/HousingProduction';
import TownSchoolMoa from './pages/TownSchoolMoa';
import { MemosList, MemoViewer } from './pages/Memos';
import { NotepadList, NotepadArticle } from './pages/Notepad';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import AcceptInvite from './pages/AcceptInvite';
import Account from './pages/Account';
import AdminConsole from './pages/AdminConsole';
import ChangePassword from './pages/ChangePassword';
import ResetPassword from './pages/ResetPassword';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />

        {/* A development-proposal study, public; not a memo and not a dashboard. */}
        <Route path="/26-pleasant-st-massing-study" element={<PleasantStreetMassing />} />
        {/* Directories of pages, like /dashboards; both public, and each card
            is filtered by what the visitor can actually open. */}
        <Route path="/faqs" element={<Faqs />} />
        <Route path="/studies" element={<Studies />} />
        <Route path="/dashboards" element={
          <ProtectedRoute pagePath="/dashboards"><Dashboards /></ProtectedRoute>
        } />

        {/* Public */}
        <Route path="/chca-faq/*" element={<ChcaFaq />} />
        <Route path="/outdoor-lighting-faq/*" element={<OutdoorLightingFaq />} />

        {/* Protected */}
        <Route path="/voters" element={
          <ProtectedRoute pagePath="/voters"><VoterLookup /></ProtectedRoute>
        } />
        <Route path="/school-staff" element={
          <ProtectedRoute pagePath="/school-staff"><SchoolStaff /></ProtectedRoute>
        } />
        <Route path="/town-budgets" element={
          <ProtectedRoute pagePath="/town-budgets"><TownBudgets /></ProtectedRoute>
        } />
        {/* Brookline for Everyone's FAQ for Warrant Articles 15 and 16. Private. */}
        <Route path="/2026-stm2-psmod-faq/*" element={
          <ProtectedRoute pagePath="/2026-stm2-psmod-faq"><PsmodFaq /></ProtectedRoute>
        } />
        {/* Petitioner's FAQ for Warrant Article 5; no questions yet, so its
            second tab is the July 2026 letter. Not public yet. */}
        <Route path="/2026-stm2-reimburse-tmms-faq/*" element={
          <ProtectedRoute pagePath="/2026-stm2-reimburse-tmms-faq"><ReimburseTmmsFaq /></ProtectedRoute>
        } />
        {/* Petitioners' FAQ for Warrant Article 7; not public yet. */}
        <Route path="/2026-stm2-crypto-kiosk-faq/*" element={
          <ProtectedRoute pagePath="/2026-stm2-crypto-kiosk-faq"><CryptoKioskFaq /></ProtectedRoute>
        } />
        {/* Public page; its Submit tab gates itself on the page permission. */}
        <Route path="/faq-platform-faq/*" element={<FaqPlatformFaq />} />
        {/* The submission form used to be its own page; it is now a tab. */}
        <Route path="/submit-faq" element={<Navigate to="/faq-platform-faq/submit" replace />} />
        <Route path="/governing-documents" element={
          <ProtectedRoute pagePath="/governing-documents"><GoverningDocsList /></ProtectedRoute>
        } />
        <Route path="/governing-documents/:docId" element={
          <ProtectedRoute pagePath="/governing-documents"><GoverningDocDetail /></ProtectedRoute>
        } />
        <Route path="/roadmap-2030" element={
          <ProtectedRoute pagePath="/roadmap-2030"><Roadmap2030 /></ProtectedRoute>
        } />
        <Route path="/carp-2026" element={
          <ProtectedRoute pagePath="/carp-2026"><Carp2026 /></ProtectedRoute>
        } />
        <Route path="/urban-forestry" element={
          <ProtectedRoute pagePath="/urban-forestry"><UrbanForestry /></ProtectedRoute>
        } />
        <Route path="/open-space" element={
          <ProtectedRoute pagePath="/open-space"><OpenSpaceRec /></ProtectedRoute>
        } />
        <Route path="/ersc-recommendations" element={
          <ProtectedRoute pagePath="/ersc-recommendations"><ErscRecommendations /></ProtectedRoute>
        } />
        <Route path="/vision-zero" element={
          <ProtectedRoute pagePath="/vision-zero"><VisionZero /></ProtectedRoute>
        } />
        <Route path="/athletic-fields" element={
          <ProtectedRoute pagePath="/athletic-fields"><AthleticFields /></ProtectedRoute>
        } />
        <Route path="/community-health-plan" element={
          <ProtectedRoute pagePath="/community-health-plan"><Chip /></ProtectedRoute>
        } />
        <Route path="/dpw-strategic-plan" element={
          <ProtectedRoute pagePath="/dpw-strategic-plan"><DpwStrategic /></ProtectedRoute>
        } />
        <Route path="/hazard-mitigation" element={
          <ProtectedRoute pagePath="/hazard-mitigation"><HazardMitigation /></ProtectedRoute>
        } />
        <Route path="/housing-production-plan" element={
          <ProtectedRoute pagePath="/housing-production-plan"><HousingProduction /></ProtectedRoute>
        } />
        <Route path="/town-school-moa" element={
          <ProtectedRoute pagePath="/town-school-moa"><TownSchoolMoa /></ProtectedRoute>
        } />
        {/* Renamed 2026-09-22 (Understanding -> Agreement); keep old links working. */}
        <Route path="/town-school-mou" element={<Navigate to="/town-school-moa" replace />} />
        <Route path="/notepad" element={<NotepadList />} />
        <Route path="/notepad/:articleId" element={<NotepadArticle />} />
        <Route path="/memos" element={
          <ProtectedRoute pagePath="/memos"><MemosList /></ProtectedRoute>
        } />
        <Route path="/memos/:memoId" element={
          <ProtectedRoute pagePath="/memos"><MemoViewer /></ProtectedRoute>
        } />

        {/* Auth pages */}
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/accept-invite" element={<AcceptInvite />} />
        <Route path="/account" element={<Account />} />
        <Route path="/admin" element={<AdminConsole />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

function NotFound() {
  return (
    <div className="not-found">
      <h1>404</h1>
      <p>Page not found</p>
      <a href="/">Go to Home</a>
    </div>
  );
}

export default App;
